import { render, staticRenderFns } from "./RecentResourceResponse.vue?vue&type=template&id=bd428094&"
import script from "./RecentResourceResponse.vue?vue&type=script&lang=js&"
export * from "./RecentResourceResponse.vue?vue&type=script&lang=js&"
import style0 from "./RecentResourceResponse.vue?vue&type=style&index=0&id=bd428094&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports